import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CommentsSection />
        <TopicsSection />
        <ContactSection />
        <FAQSection />
        <AboutSection />
        <AppSection />
        <IndexSection />
        <RankingSection />
        <CarouselSection />
        <UpdatesSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}